import { omdApi } from '../../api';
import '../types';
import { InvoiceVersions } from '../types';

const report = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    reportInvoiceVersions: builder.query<InvoiceVersions[], void>({
      query: () => ({
        url: '/v1/Report/invoiceVersions',
      }),
    }),
  }),
});

export const { useLazyReportInvoiceVersionsQuery, useReportInvoiceVersionsQuery } = report;
